<template>
  <main role="main">
    <b-container class="py-4" style="max-width: 700px;">
      <h4>{{ $t("changePassword") }}</h4>
      <b-alert v-if="reason" variant="warning" show>{{ reason }}</b-alert>
      <b-alert v-if="formErrorMsg" variant="danger" show>{{ $t(formErrorMsg) }}</b-alert>

      <b-form @submit.prevent="submitForm">
        <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
        <template v-if="!isLoading && passwordPolicy">
          <b-form-group>
            <template v-slot:label>{{ $t("currentPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="password" required v-model="currentPassword" />
          </b-form-group>
          <b-form-group :description="passwordPolicy.passwordDescription">
            <template v-slot:label>{{ $t("newPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="text" required v-model="newPassword" class="masked-password" autocomplete="off"
                          :minlength="passwordPolicy.minPasswordLength"
                          :maxlength="passwordPolicy.maxPasswordLength"
                          :pattern="passwordPolicy.passwordPattern"
                          @invalid.native="$event.target.setCustomValidity(passwordPolicy.passwordValidationFailedMessage)"
                          @input.native="$event.target.setCustomValidity('')"/>
          </b-form-group>
          <b-form-group>
            <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="text" class="masked-password" autocomplete="off" required v-model="confirmPassword"/>
          </b-form-group>

          <div class="text-center pt-3">
            <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
          </div>
        </template>
      </b-form>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as passwordPolicyService from "@/service/passwordPolicyService";
  import * as userService from "@/service/userService";
  import environment from "@/environment";

  @Component
  export default class ChangePassword extends BaseComponent {

    isLoading = true;
    reason = "";

    passwordPolicy = null;

    currentPassword = "";
    newPassword = "";
    confirmPassword = "";

    formErrorMsg = "";
    isSubmitting = false;

    mounted() {
      // this.reason = userService.getCurrentUser().changePasswordMessage ?? 'N/A';
      this.fetchPasswordPolicy();
    }

    async fetchPasswordPolicy() {
      try {
        this.isLoading = true;
        this.passwordPolicy = await passwordPolicyService.get();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    async submitForm() {
      this.formErrorMsg = null;

      if (this.newPassword !== this.confirmPassword) {
        this.formErrorMsg = "passwordsNotMatch";
        return;
      }

      if (this.newPassword === this.currentPassword) {
      this.formErrorMsg = "passwordhasbeenusedbefore";
      return;
      }

      try {
        this.isSubmitting = true;
        await userService.changeMyPassword(this.currentPassword, this.newPassword);
        //await userService.reFetchCurrentUser();
        this.showSuccessModal();

      } catch (e) {
        this.formErrorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isSubmitting = false;
      }
    }

    async showSuccessModal() {
      await this.$bvModal.msgBoxOk(this.$t("passwordChangedSuccessful").toString(), {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true
      });
      userService.signOut();
    }

  }
</script>
